import { useState } from "react";
import CarousselNav from "../../components/Card/CarousselNav";
import Activite from "./Activite";
import CategoryTop from "./CategoryTop";
import DestinationTop from "./DestinationTop";
import EventTop from "./EventTop";
import IdentitieTop from "./IdentitieTop";
import Roaming from "./Roaming";
import Threat from "./Threat";
import { Link } from "react-router-dom";
import Trafic from "./Trafic";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Loader from "../../components/Loader";
import ButtonArrow from "../../components/ButtonArrow";
import { useTranslation } from "react-i18next";

export default function Umbrella() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { apiUrl } = useContext(AuthContext)
  const { t } = useTranslation();

  //Request
  const getSummary = async () => {

    const res = await axios(`${apiUrl}umbrella/summary/7/10`, {
      method: "get",
      withCredentials: true,
    })
    return res.data.data
  };

  const summary = useQuery({
    queryKey: ["summary"],
    queryFn: getSummary
  })

  const valuesType = ["Activité", "Client Umbrella", "Trafic bloqué", "Menaces", "Top events", "Top identités", "Top destinations", "Top catégories"];



  if (summary.isError) {
    return (
      <div className="ecp-container">
        <div className="ecp-container-content-error">
          <div className="error-container">
            <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
            <div className="error-container-text">
              <h1 className="page-title">
                {t("Aucun équipement Umbrella disponible")}
              </h1>
              <p className="page-link_home">
                <Link to="/"> {t("Revenir à l'accueil")}</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="ecp-container">
      <div className="ecp-container-content">
        {!summary.isLoading ? <>
          <div className="ecp-container-content-header">
            <div className="ecp-container-content-header-title">
              <div className="page-title page-logo">
                <img src="./assets/cisco_logo.png" alt="logo de cisco Umbrella" />
                <h1 className="page-title">Cisco Umbrella</h1>
                <ButtonArrow url={"https://login.umbrella.com/"} />
              </div>
              <CarousselNav arrayValues={valuesType} currentSlide={currentSlide} setCurrentSlide={setCurrentSlide} />
            </div>
          </div>
          {/* {valuesType[currentSlide] === "Résumé" && <Summary />} */}
          {valuesType[currentSlide] === "Activité" && <Activite />}
          {valuesType[currentSlide] === "Client Umbrella" && <Roaming />}
          {valuesType[currentSlide] === "Trafic bloqué" && <Trafic />}
          {valuesType[currentSlide] === "Menaces" && <Threat />}
          {valuesType[currentSlide] === "Top events" && <EventTop />}
          {valuesType[currentSlide] === "Top identités" && <IdentitieTop />}
          {valuesType[currentSlide] === "Top destinations" && <DestinationTop />}
          {valuesType[currentSlide] === "Top catégories" && <CategoryTop />}
        </> : <Loader />}
      </div>
    </div>
  );
}
